<script>
export default {
  name: 'Agb',
  title: 'AGB',
  data() {
    return {
      publicPath: window.config.VUE_APP_BASE_URL,
      fileName: 'AGB'
    }
  }
}
</script>
<template>
  <embed
    :src="`${publicPath}/pdf/${fileName}.pdf`"
    type="application/pdf"
    width="100%"
    height="100%"
  />
</template>
